import { NavLink } from 'react-router-dom';
import classNames from 'classnames';

import { useCurrentUser } from '../../context';
import { RouteType } from '../../models';
import {
  hasAccess,
  isDashboardsPath,
  isDocumentsPath,
  isUserManagementPath,
} from '../../utils';

type TopMenuItemProps = Pick<RouteType, 'requiredRoles' | 'name' | 'path'> & {
  isLink?: boolean;
};

export const TopMenuItem = ({
  requiredRoles = [],
  name,
  path,
  isLink,
}: TopMenuItemProps) => {
  const { role, hasTableauAccess } = useCurrentUser();

  if (
    !hasAccess(role, requiredRoles) ||
    (isDashboardsPath(path) && !hasTableauAccess)
  ) {
    return null;
  }

  return (
    <li>
      <NavLink
        className={classNames(
          'p-3 rounded text-teal-500',
          'focus:outline-none focus:ring focus:ring-teal-500 focus:ring-opacity-50'
        )}
        activeClassName="bg-teal-200 font-medium"
        to={{ pathname: path }}
        target={isLink ? '_blank' : undefined}
        {...(isDocumentsPath(path) && {
          isActive: (_, location) => isDocumentsPath(location.pathname),
        })}
        {...(isUserManagementPath(path) && {
          isActive: (_, location) => isUserManagementPath(location.pathname),
        })}
        {...(isDashboardsPath(path) && {
          isActive: (_, location) => isDashboardsPath(location.pathname),
        })}
      >
        {name}
      </NavLink>
    </li>
  );
};
